'use client';

import { createContext, useContext, useEffect } from 'react';
import {
  DEFAULT_MENU_VISIBILITY,
  type MenuVisibility,
} from '@shared/services/menuVisibility';
import { writeOfflinePrefs } from '@/lib/offlinePrefsMirror';

// Видимость пунктов меню/счётчиков, засеянная на сервере (root layout читает
// users.menu_visibility и передаёт сюда). Navbar и DashboardShell читают это
// через useMenu() без проброса пропсов по всем страницам. После переключения
// тумблеров в настройках вызывается router.refresh() → layout пересчитывается
// → провайдер пере-засевается свежим значением (без мигания на первом рендере).
const MenuContext = createContext<MenuVisibility>(DEFAULT_MENU_VISIBILITY);

export function MenuProvider({
  value,
  children,
}: {
  value: MenuVisibility;
  children: React.ReactNode;
}) {
  // Зеркало для офлайн-страниц: offline-catalog.html читает menu из
  // localStorage, чтобы нижний бар вёл себя как онлайн (по умолчанию скрыт).
  useEffect(() => {
    writeOfflinePrefs({ menu: value });
  }, [value]);

  return <MenuContext.Provider value={value}>{children}</MenuContext.Provider>;
}

export const useMenu = () => useContext(MenuContext);
